<template>
    <div :class="[(form.errors.ca_consent) ? '!border-2 !border-red-600 !shadow-md !shadow-red-500' : 'border border-gray-200','bg-white rounded-md shadow-sm mt-6']">
        <!-- Header Section -->
        <div class="sm:col-span-6 flex justify-between items-center border-b border-gray-200 py-4 px-6">
            <div>
                <h4 class="text-xl font-bold text-gray-700 sm:text-2xl">For Tenants with a California Mailing Address</h4>
                <p class="text-sm text-gray-500 mt-1">California Consumer Credit Reporting Agencies Act Disclosure and Authorization</p>
            </div>
            <div v-if="form.errors.ca_consent">
                <font-awesome-icon :icon="faExclamationTriangle" size="2x" class="text-red-500" />
            </div>
        </div>
        
        <!-- Content Section -->
        <div class="p-6">
            <div class="bg-yellow-50 rounded-lg p-4 mb-4">
                <p class="text-sm text-gray-700 leading-relaxed mb-3">
                    I have carefully read and understand the California Consumer Credit Reporting Agencies Act Disclosure and Authorization forms. By clicking the checkbox below, I consent to the preparation of consumer credit reports by a consumer reporting agency, and to the release of such reports to such prospective landlords, and real estate agents as I shall designate, for the purpose of assisting such prospective landlords, and real estate agents in conducting tenant screening.
                </p>
                <p class="text-sm text-gray-700 leading-relaxed">
                    I authorize consumer reporting agencies to disclose information about me to such prospective landlords, and real estate agents any information about or concerning me. The information that can be disclosed includes my credit history, and I agree that this form in original, faxed, photocopied or electronic (including electronically signed) form, will be valid for any consumer credit reports that I request be transferred on my behalf.
                </p>
            </div>
            
            <div class="mt-4">
                <label class="flex items-start space-x-3">
                    <input 
                        id="ca_consent" 
                        type="checkbox" 
                        v-model="form.ca_consent" 
                        :value="1"
                        class="mt-1 rounded border-gray-300 text-rent-risk-blue-400 focus:ring-rent-risk-blue-400 h-4 w-4" 
                    />
                    <span class="text-sm font-medium text-gray-700">
                        I have read and agree to the 
                        <a href="https://www.icraa.com" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">
                            California Consumer Credit Reporting Agencies Act Disclosure and Authorization
                        </a>
                    </span>
                </label>
                <p v-if="form.errors.ca_consent" class="text-red-500 text-sm mt-2 ml-7">
                    {{ form.errors.ca_consent }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

export default {
    components: {
        FontAwesomeIcon
    },
    props: {
        form: Object,
        application: Object,
        states: Object,
        validateField: Function,
    },
    data() {
        return {
            faExclamationTriangle
        }
    },
}
</script>